<template>
  <div class="contact-us">
    <v-card class="common-card grey lighten-4">
      <h4 class="shopDeeppurple--text fs-xxlarge">تماس با ما</h4>

      <div class="mt-8">
        <h1>راه های ارتباطی با ما :</h1>
        <div v-for="(item, index) in contactInfo" :key="index" class="mb-4">
          <a v-if="item.to" :href="item.to" target="_blank">
            <v-icon class="mb-2 orange-icon">{{ item.icon }}</v-icon>
            <span class="mr-1 mainFont--text fs-medium">{{ item.name }}</span>
            <span class="mr-1 mainFont--text fs-medium">{{ item.data }}</span>
          </a>
          <div v-else class="orange-icon">
            <v-icon class="mb-2 orange-icon">{{ item.icon }}</v-icon>
            <span class="mr-1 mainFont--text fs-medium">{{ item.name }}</span>
            <span class="mr-1 mainFont--text fs-medium">{{ item.data }}</span>
          </div>
        </div>
        <div class="mb-4">
          <a href="https://www.aparat.com/ketabbaaz.com" target="_blank">
            <img
              src="@/assets/aparat.png"
              alt="Aparat Icon"
              style="width: 24px; height: 24px"
            />
            <span class="mr-1 mainFont--text fs-medium">آپارات:</span>
            <span class="mr-1 mainFont--text fs-medium"
              >https://www.aparat.com/ketabbaaz.com</span
            >
          </a>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      contactInfo: [
        {
          name: "ایمیل:",
          icon: "$Email",
          data: "info@ketabbaaz.com",
          to: "mailto:info@ketabbaaz.com",
        },
        {
          name: "اینستاگرام:",
          icon: "$Instagram",
          data: "ketabbaaz.com",
          to: "https://www.instagram.com/ketabbaaz.com/",
        },
        {
          name: "تلگرام:",
          icon: "$Telegram",
          data: "https://t.me/ketabbaaz.com",
          to: "https://t.me/ketabbaaz.com",
        },
        {
          name: "شماره تماس:",
          icon: "mdi-phone",
          data: "02166120447(ساعت پاسخگویی 11 الی 19)",
          to: "tel:02166120447",
        },
      ],
    };
  },
  metaInfo() {
    return {
      title: `تماس با ما| کتاب باز`, // Meta title
      meta: [
        {
          name: "description",
          content: "تماس با فروشگاه آنلاین کتاب باز", // Meta description
        },
        {
          property: "og:title", // Open Graph meta tag
          content: "تماس با ما",
        },
        {
          property: "og:description",
          content: "تماس با فروشگاه آنلاین کتاب باز",
        },
      ],
    };
  },
  beforeDestroy() {
    // Reset the meta title when leaving the page
    document.title = "کتاب باز"; // Replace with your default title
    // Optionally, remove any other meta tags
    const metaTags = document.querySelectorAll(
      "meta[data-vue-router-controlled]"
    );
    metaTags.forEach((tag) => tag.parentNode.removeChild(tag));
  },
};
</script>

<style lang="scss">
.text-contactUs {
  font-weight: 600;
  font-size: 16px;
  text-align: right;
}
.contact-us {
  overflow: hidden;
  h1 {
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 10px;
  }
  .common-card {
    position: relative;
    @media only screen and (max-width: 600px) {
      padding-bottom: 200px;
    }
    .image-box {
      position: absolute;
      left: 30px;
      bottom: -22px;
      @media only screen and (max-width: 600px) {
        left: 10px;
      }
    }
  }
}
</style>
